export default __webpack_public_path__ + "static/media/logo.e7ddf0d6.svg";